



















































import { Vue, Prop, Component, Emit } from 'vue-property-decorator'
import config from '../http/config'

@Component
export default class HomeVideo extends Vue {
  videoPlay = true
  pauseVideo () {
    if (this.videoPlay) {
      $('#home-video').trigger('pause')
    } else {
      $('#home-video').trigger('play')
    }
    this.videoPlay = !this.videoPlay
  }
  @Emit('experienceParent')
  experience () {
    window.zhuge.track('点击立即体验')
    // window._czc.push([ '_trackEvent', '官网首页', '按钮链接点击', '立即体验', '' ])
    // window.location.href = config.rootDomain + '/app/index'
    return new Promise(resolve => {
      $('html').animate({ scrollTop: '570px' }, 500, () => {
        resolve()
      })
    })
  }
}
